module.exports = __webpack_public_path__ + "static/img/adminssion.97130d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adminssion.png
// module id = Hy+Q
// module chunks = 1